import {
    Box,
    CardContent,
    Grid,
    Typography,
    CardActions,
    Select,
    MenuItem,
    Divider,
    Card,
    Button,
    usePagination,
    TableBody,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ApexCharts from "react-apexcharts";
import React, { useEffect, useMemo } from "react";
import fileBrowser from "../icons/file-browser.svg";
import cssVariables from "../theme/cssVariables";
import { ReactComponent as Previous } from "../icons/previous.svg";
import { ReactComponent as Next } from "../icons/next.svg";
import { ReactComponent as KpiArrow } from "../icons/kpiArrow.svg";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { makeStyles, styled } from "@mui/styles";

const useStyles = makeStyles({
    media: {
        height: 200,
    },
    clickable: {
        cursor: "pointer",
        textAlign: "center",
        transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        '&:hover': {
            color: 'rgb(65, 112, 105) !important'
        }
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    customCardSize: {
        minHeight: 490,
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
    styleText: {
        textDecoration: "underline",
        fontWeight: "500",
    },
    styleScroll: {
        color: "#5DA196",
        paddingLeft: "30px",
        paddingRight: "20px",
    },
    processBgYellow: {
        background: "#EFB76D26",
    },
    processTextYellow: {
        color: "#EFB76D",
    },
    processBgOrange: {
        background: "#F2802626",
    },
    processTextOrange: {
        color: "#F28026",
    },
    processBgGreen: {
        background: "#5DA19626",
    },
    processTextGreen: {
        color: "#5DA196",
    },
    processBgRed: {
        background: "#CC605826",
    },
    processTextRed: {
        color: "#CC6058",
    },
    processBgGrary: {
        background: "#82828226",
    },
    processTextGrary: {
        color: "#828282",
    },
});
const styles = {
    bannerImage: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        maxWidth: "336px",
        height: "auto",
    },
    blueBadge: {
        background: "rgb(83 135 198 / 15%)",
        padding: "2px",
        color: "#5387C6",
    },
    blockGrid: {
        padding: "38px 0 0 0",
    },
    barLegend: {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#939393",
    },
};
function CustomPagination(props) {
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "0 !important",
            border: "none !important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                        } else if (type === "first" || type === "last") {
                        } else {
                            children = (
                                <BootstrapTooltip title={type === "previous" ? "Previous" : type === "next" ? "Next" : ""} placement="top">
                                    <Box>
                                        <Button
                                            {...item}
                                            disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                            size="small"
                                            type="button"
                                            variant="outlined"
                                            classes={{
                                                root: classes.paginationRoot,
                                            }}
                                        >
                                            {type === "previous"
                                                ? <Previous />
                                                : type === "next"
                                                    ? <Next />
                                                    : ""}
                                        </Button>
                                    </Box>
                                </BootstrapTooltip>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}
const BarChartPlanning = (props) => {
    const { t } = useTranslation();

    const { data, title, callBack, path, icon } = props;
    const [dataBarChart, setDataBarChart] = React.useState([]);
    const [perPage, setPerPage] = React.useState(5);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const classes = useStyles();
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const handleTotalPage = () => {
        const List = data;
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };

    const currentTableData = useMemo(() => {
        handleTotalPage();
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return data
            ?.slice(firstPageIndex, lastPageIndex);
    }, [currentPage]);

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };
    useEffect(() => {
        handleTotalPage();
    }, [data]);
    let linkPath = () => {
        if (path !== undefined && path !== null && path !== "") {
            callBack(path)
        }
    }
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));
    return (
        <Card classes={{ root: classes.customCardSize }} sx={{ position: "relative" }}>
            <Box px={2} style={{ height: "100%" }} >
                <CardContent sx={{ paddingLeft: "0px", paddingRight: "0px" }}>
                    <Grid item sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Grid container spacing={0}>
                            <Grid item>
                                <Box sx={{ height: "40px", background: "#FA9349", "border-radius": "5px", padding: "10px" }}>
                                    <img src={icon} alt="myGoals" style={{ height: "20px" }} />
                                </Box>
                            </Grid>
                            <Grid item ml={1} display="flex" alignItems="center">
                                <Grid container spacing={0}>
                                    <Grid item>
                                        <Typography
                                            fontSize={20}
                                            lineHeight="22px"
                                            sx={{ fontWeight: "600" }}
                                        >
                                            {title}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Box sx={{ flex: 2 }}></Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Box mt="4px">
                                {/* {data?.code === "y" ? */}
                                <BootstrapTooltip title={`View My Goal`} placement="top">
                                    <KpiArrow style={{ cursor: "pointer" }} />
                                </BootstrapTooltip>
                                {/* : null
                                } */}
                            </Box>
                        </Box>
                    </Grid>
                </CardContent>
                <Divider />
                {currentTableData.length > 0 ?
                    <Box>
                        <Box aria-label="collapsible table">
                            <Box>
                                <Box sx={{ display: "flex" }}>
                                    <Box sx={{ padding: "13px 10px", width: "calc(100% - 230px)" }}><Typography variant="label" fontWeight={400} fontSize={16} color="#A0A0A0">Goals</Typography></Box>
                                    <Box sx={{ padding: "13px 10px", width: "90px" }}><Typography variant="label" fontWeight={400} fontSize={16} color="#A0A0A0">Weight</Typography></Box>
                                    <Box sx={{ padding: "13px 10px", width: "140px", textAlign: "center" }}><Typography variant="label" fontSize={16} fontWeight={400} color="#A0A0A0">Goal Status</Typography></Box>
                                </Box>
                            </Box>
                            <Divider />
                            <Box>
                                {
                                    currentTableData.map(item => (
                                        <Box sx={{ display: "flex" }}>
                                            <Box sx={{ padding: "20px 10px 0", border: "none", height: "60px", width: "calc(100% - 230px)" }}><Typography py={1} sx={{ overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis", width: "100%" }} fontSize={16} fontWeight={400}>{item.name}</Typography></Box>
                                            <Box sx={{ padding: "20px 10px 0", border: "none", height: "60px", width: "90px" }}><Typography py={1} fontSize={16} fontWeight={400}>{item.weight}</Typography></Box>
                                            <Box sx={{ padding: "20px 10px 0", border: "none", height: "60px", width: "140px" }}>
                                                <Box className={`${classes.statusBadge}  
                                                                    ${item?.status === "draft" ?
                                                        classes.processBgYellow
                                                        : item?.status === "pending" || item?.status === "pending_cancel" ?
                                                            classes.processBgOrange
                                                            : item?.status === "approved" ?
                                                                classes.processBgGreen
                                                                : item?.status === "cancel_cancel" || item?.status === "cancel" ?
                                                                    classes.processBgGrary : classes.processBgRed}`}
                                                    sx={{ padding: "8px 0", width: "120px", "border-radius": "5px" }}>
                                                    <BootstrapTooltip title={
                                                        item?.status === "draft" ?
                                                            "draft"
                                                            : item?.status === "pending" || item?.status === "pending_cancel" ?
                                                                "pending && pending_cancel"
                                                                : item?.status === "approved" ?
                                                                    "approved"
                                                                    : item?.status === "cancel_cancel" || item?.status === "cancel" ?
                                                                        "cancel_cancel" : "cancel_cancel"} placement="top">
                                                        <Typography className={
                                                            item?.status === "draft" ?
                                                                classes.processTextYellow
                                                                : item?.status === "pending" || item?.status === "pending_cancel" ?
                                                                    classes.processTextOrange
                                                                    : item?.status === "approved" ?
                                                                        classes.processTextGreen
                                                                        : item?.status === "cancel_cancel" || item?.status === "cancel" ?
                                                                            classes.processTextGrary : classes.processTextRed}
                                                            sx={{ textAlign: "center" }}
                                                            fontWeight={400}
                                                            fontSize={16}
                                                        >
                                                            {item.status}
                                                        </Typography>
                                                    </BootstrapTooltip>
                                                </Box>
                                            </Box>
                                        </Box>
                                    ))
                                }
                            </Box>
                        </Box>
                    </Box>
                    :
                    <CardContent className={classes.cardContentSize}>
                        <Box>
                            <img src={fileBrowser} alt="browser" />
                        </Box>
                        {data?.code === "y" ?
                            <Box>
                                <Typography sx={{ color: "#939393" }}>
                                    ยังไม่มีข้อมูล หากต้องการเพิ่มข้อมูลให้ <br />
                                    <Typography
                                        classes={{ root: classes.clickable }}
                                        style={{ color: "#5DA196", fontWeight: "500", textDecoration: "underline" }}
                                        onClick={linkPath}
                                    >
                                        {/* {t("portfolio.label.clickhere")} */}
                                        คลิกที่นี่
                                    </Typography>
                                </Typography>
                            </Box>
                            :
                            <Box>
                                <Typography sx={{ color: "#939393" }}>
                                    ยังไม่มีข้อมูล
                                </Typography>
                            </Box>}
                    </CardContent>
                }
                <Box container position="absolute" right="7px" bottom="20px" mt="1px" spacing={2} display="flex">
                    <Typography color={cssVariables.color.primary} fontSize="16px" fontWeight="300" mr="5px">
                        {currentPage} / {totalPage}
                    </Typography>
                    <CustomPagination
                        setCurrentPage={handleSetCurrentPage}
                        selected={currentPage}
                        count={totalPage}
                    ></CustomPagination>
                </Box>
            </Box>
        </Card>
    );
};
export default BarChartPlanning;
